import { Context, Http } from '@fe/g-utils';
import { isBrowser } from '../env';
import fetch from './fetch';

const http = new Http(fetch as any);

http.useMiddleware(async (ctx: Context, next) => {
  if (isBrowser) {
    const prefetch = (window as any).__prefetch__;
    if (prefetch) {
      const key = ctx.req?.options?.prefetchId;
      const p = prefetch.getPrefetchData(key);
      if (p) {
        ctx.res = await p;
        return ctx;
      }
    }
    return next();
  } else {
    return next();
  }
});
export default http;
